import { Component,ViewChild} from '@angular/core';
import { NavController, NavParams,LoadingController } from 'ionic-angular';
import { DatePipe } from '@angular/common';
import { SummaryServiceProvider } from '../../../providers/wh/summary-service';
import { ShipmentsPage } from '../../backoffice/shipments/shipments';
import { Chart } from 'chart.js';

@Component({
  selector: 'page-parcels-dashboard',
  templateUrl: 'index.html',
  providers: [SummaryServiceProvider]
})
export class ParcelDashboard {

   @ViewChild("barChart") barChart;

  header_data:any;
  public avl_rules: any = "";
  dashboard_data: any = "";
  public data1:any;
  public data2:any;
  public my_labels:any;
  public my_series:any;
  public my_data:any;
public myLineChart:any;

  constructor(public datepipe: DatePipe,public navCtrl: NavController, public navParams: NavParams, public summaryService: SummaryServiceProvider,public loadingCtrl: LoadingController)
  {
       this.header_data={ismenu:true,ishome:false,title:"Parcels Dashboard"};
      this.load_dashboard_data(true);
  this.timeout();     
  }


 ngAfterViewInit() {
    console.log("afterinit");
    setTimeout(() => {
      console.log(this.barChart.nativeElement);
    }, 1000);
  }


timeout() {

  setTimeout(() => this.load_dashboard_data(false), 600000);
  setTimeout(() => this.timeout(), 600000);


}


  load_dashboard_data(show_loader) {
    let q: any = '';

    if (this.avl_rules.length>0) {
      q += '&rules=' + this.avl_rules;
    }



    if (show_loader) {
      let loader = this.loadingCtrl.create({
        content: "Please wait..."
      });
      loader.present();

      this.summaryService.load_dashboard_active_parcels_data(q)
        .then(data => {
          this.dashboard_data = data;
          //console.log(this.dashboard_data);

    this.createDriverBarChart(this.dashboard_data.data);
        });

      loader.dismiss();
    }
    else {
      this.summaryService.load_dashboard_active_parcels_data(q)
        .then(data => {
          this.dashboard_data = data;
          this.createDriverBarChart(this.dashboard_data.data);
        });
    }

  }

  gotoSearch(awbs) {
    this.navCtrl.push(ShipmentsPage, {
      awbs_param: awbs
    });
  }




createDriverBarChart(data)
{
  console.log('provided data');
  console.log(data);

  this.data1={};
  this.data1.labels=[];
  this.data1.datasets=[];

  this.data2={};
  this.data2.labels=[];
  this.data2.datasets=[];


 let colors = ["#9ACFE0E6","#E0B19A","#E0C79A","#B1C28C","#CAE09A","#C0ABDAB3","#B99AE0","#B5BBC8","#9199A9","#EFBD76","#FCE0B7"];

  let g:number=0;
  for (let d of data.summary.items) {
      this.data1.datasets.push({
           backgroundColor:colors[g],
           data:[],
           label:d.label
          });

      this.data2.datasets.push({
           backgroundColor:colors[g],
           data:[],
           label:d.label
          });


      g++;
  }

  let x=0,y=0
  for (let e of data.summary.stats) {
       if(e.label!=='COD at CP for driver'
        && e.label!=='COD at CP for transfer'
        && e.label!=='COD with driver')
        {
          this.data1.labels.push(e.label+' ('+e.value+')');
        x++;
      }else{
          this.data2.labels.push(e.label+' ('+e.value+')');
        y++;
     }
  }


  let sets: Array<{[key:number]: {[key:number]: Array<{}>}}>=[];
  let sets2: Array<{[key:number]: {[key:number]: Array<{}>}}>=[];
  let p=0;
  for (let d of data.summary.items) {
    let sub_set:Array<{}>=[];
    let sub_set2:Array<{}>=[];
        let q=0,r=0;
        for (let ex of d.stats) {
          if(ex.label!=='COD at CP for driver'
           &&ex.label!=='COD at CP for transfer'
           &&ex.label!=='COD with driver')
          {
              sub_set[q]=(ex.value);
            q++;
          }else
          {
            let val=ex.value;
              sub_set2[r]=(val.replace(/\D/g,''));
            r++;
          }
        }
        sets.push(sub_set);
        sets2.push(sub_set2);
      p++;
  }


  let o=0;
  for (let d of data.summary.items) {
      this.data1.datasets[o].data=sets[o];
      this.data2.datasets[o].data=sets2[o];
      o++;
  }

console.log(this.data1);



 if(this.myLineChart){
               this.myLineChart.destroy();
         }

    setTimeout(() => {
   console.log(this.barChart.nativeElement);

   this.myLineChart = new Chart(this.barChart.nativeElement,
   {
     type: 'horizontalBar',
    data: this.data1,
    options: {
        "animation": {
            "duration": 1000,
            "onComplete": function() {
                var chartInstance = this.chart,
                    ctx = chartInstance.ctx;

                ctx.font = Chart.helpers.fontString(8, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                ctx.textAlign = 'center';
                ctx.textBaseline = 'bottom';

                this.data.datasets.forEach(function(dataset, i) {
                    var meta = chartInstance.controller.getDatasetMeta(i);
                    meta.data.forEach(function(bar, index) {
                        var data = dataset.data[index];
                        ctx.fillText(data, bar._model.x+5, bar._model.y + 5);
                    });
                });
            }
        },
        maintainAspectRatio: true,
        legend: {
            display: true,
            boxWidth: 80,
            fontSize: 8,
            padding: 0
        },
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                    stepSize: 5
                }
            }],
            xAxes: [{
                ticks: {
                    autoSkip: false,
                    beginAtZero: true,
                }
            }]
        }
      }
  });


    }, 1000);
}




}



// WEBPACK FOOTER //
// ./src/pages/qdb/parcel-dashboard/index.ts